/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { DefaultSplitDataRenderType } from '@touchplan/common';
import { CustomFieldTicketValue, ICustomFieldTicket } from 'src/app/app-data/models/CustomFieldTicketValue';

export class CustomFieldTicketValueList extends FancyFirebaseSplitDataList<
	ICustomFieldTicket,
	DefaultSplitDataRenderType,
	CustomFieldTicketValue
> {
	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		super(angularLand, path, fancyJoins);
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		const value = new CustomFieldTicketValue(action.payload.key);
		value.databaseUpdate(action.payload.val());
		return value;
	}
}
